// Product Card Carousel Enhancement - Mobile Only
document.addEventListener('DOMContentLoaded', function() {
  // Only enable carousel functionality on mobile devices
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  
  if (!isMobile) {
    return; // Exit early on desktop
  }
  
  // Enhance product card carousels with better touch support
  const productCardCarousels = document.querySelectorAll('.product-card__carousel');
  
  productCardCarousels.forEach(carousel => {
    // Prevent accidental link clicks during swipe
    let isScrolling = false;
    let scrollTimeout;
    
    carousel.addEventListener('scroll', function() {
      isScrolling = true;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
      }, 150);
    });
    
    // Prevent navigation on carousel links while scrolling
    carousel.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function(e) {
        if (isScrolling) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });
    
    // Add smooth scroll behavior for older browsers
    if (!CSS.supports('scroll-behavior', 'smooth')) {
      carousel.style.scrollBehavior = 'smooth';
    }
  });
  
  // Observe new product cards added dynamically (e.g., infinite scroll)
  const observer = new MutationObserver(function(mutations) {
    // Check if still on mobile before processing
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) {
      return;
    }
    
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('product-card')) {
          const carousel = node.querySelector('.product-card__carousel');
          if (carousel) {
            // Apply same enhancements to new carousel
            let isScrolling = false;
            let scrollTimeout;
            
            carousel.addEventListener('scroll', function() {
              isScrolling = true;
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                isScrolling = false;
              }, 150);
            });
            
            carousel.querySelectorAll('a').forEach(link => {
              link.addEventListener('click', function(e) {
                if (isScrolling) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              });
            });
          }
        }
      });
    });
  });
  
  // Start observing for new product cards
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
